import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivityInternalWrapperComponent } from 'gung-standard';
import { CultActivityInternalListConfigService } from '../../services/cult-activity-internal-list-config.service';

@Component({
  selector: 'cult-activity-internal-wrapper',
  templateUrl: './cult-activity-internal-wrapper.component.html',
  styleUrls: ['./cult-activity-internal-wrapper.component.scss'],
  standalone: false
})
export class CultActivityInternalWrapperComponent extends ActivityInternalWrapperComponent implements OnInit {
  private route = inject(ActivatedRoute);
  public cultActivityInternalListConfigService = inject(CultActivityInternalListConfigService);

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.cultActivityInternalListConfigService.activityType.next(params.type);
    });
  }
}
